const Footer = () => {
  return (
    <footer>
      <span>
        Github Profile <a href='https://github.com/ShipFriend0516'>ShipFriend0516</a>
      </span>
      <span>API by <a href='https://www.themoviedb.org/'>TMDB</a></span>
      <span>MovieWeb @{new Date().getFullYear()}</span>
    </footer>
  )

}

export default Footer;